import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Nenhum contato adicionado ainda", -1)
const _hoisted_4 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { key: 4 }
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-xl-21" }, null, -1)
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_contato_pessoa_modal = _resolveComponent("contato-pessoa-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_table, {
          columns: _ctx.state.colunasGrade.filter(item => item.visible),
          "data-source": _ctx.computedContatosPessoa,
          rowKey: "codigo",
          pagination: false,
          scroll: { x: _ctx.state.windowWidth , y: 100},
          size: "small"
        }, {
          emptyText: _withCtx(() => [
            _hoisted_3
          ]),
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'acoes')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("a", {
                    class: "visualizar",
                    onClick: ($event: any) => (_ctx.editarContato(record))
                  }, [
                    _createVNode(_component_icone, { nome: "editar" })
                  ], 8, _hoisted_5),
                  _createElementVNode("a", {
                    onClick: ($event: any) => (_ctx.confirmaExclusao(record)),
                    class: "excluir"
                  }, [
                    _createVNode(_component_icone, { nome: "excluir" })
                  ], 8, _hoisted_6)
                ]))
              : (column.key === 'TipoContato')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.obterDescricaoTipoContato(record.contato.codigoTipoContato)), 1))
                : (column.key === 'Nome')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(record.contato.nome), 1))
                  : (column.key === 'Email')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(record.contato.email), 1))
                    : (column.key === 'Telefones')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.preencherTelefones(record.contato.telefones)), 1))
                      : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source", "scroll"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "ant-btn ant-btn-secondary ss-acao-destaque-secundaria",
          style: {"margin-top":"5px","width":"100%"},
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.novoContato && _ctx.novoContato(...args)))
        }, "Novo Contato")
      ])
    ]),
    _createVNode(_component_contato_pessoa_modal, {
      ref: "refContatoPessoaModal",
      relacoes: _ctx.props.relacoes,
      empresas: _ctx.props.empresas,
      listaTiposContatos: _ctx.state.listaTiposContato,
      "onUpdate:listaTiposContatos": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.listaTiposContato) = $event)),
      onSalvarContato: _ctx.salvarContato
    }, null, 8, ["relacoes", "empresas", "listaTiposContatos", "onSalvarContato"])
  ]))
}